import { ReactNode } from "react";

export const enum Environment {
  DEV = "DEV",
  QA = "QA",
  PROD = "PROD",
  LOCAL = "LOCAL",
}

export const enum ConfigPageIndex {
  CONFIGURATIONS = "0",
  EMAIL_TEMPL = "1",
  SMS_TEXT_TEMPL = "2",
  UI_CUSTOMIZATION = "3",
  IMPORT_EXPORT = "4",
  CLEVER_CONFIG = "5",
  PAISLEY_CONFIG = "6",
  SHAPEFILES = "7",
  SEAT_LIMITS = "8",
  SCHOOL_DIRECTORY = "9",
  FEEDER_PATTERNS = "10",
  PROGRAM_CODES = "11",
}

/**
 * Org-level overrides for program code display names, keyed by program code.
 * Stored as the generic JSON config for ConfigPageIndex.PROGRAM_CODES; codes
 * absent from the map fall back to the built-in defaults.
 */
export type ProgramCodeOverrides = Record<string, string>;

export const enum FormType {
  TEXTFIELD = "textfield",
  TEXTAREA = "textarea",
  SELECT = "select",
  CHECKBOX = "checkbox",
  RADIO = "radio",
  FILE = "file",
  CODE_EDITOR = "codeeditor",
}

export enum ImageConfigs {
  LOGO = "logo",
  SCHOOL_LOGO = "districtSchoolLogo",
  BANNER = "banner",
}

export interface SiteConfigs {
  config01: string;
  select01: string;
  checkbox01: string;
  radio1: string;
  address: string;
  radio02: string;
  checkbox02: string;
  showBannerLogo: boolean;
  enableZoneGroup?: string;
  enableStudentRosterImport?: string;
  enableEnrollmentCapacity?: string;
  enableProgramDemand?: string;
  enableDataPipelineImport?: string;
  enableDocumentArchive?: string;
  archiveBucket?: string;
  mappingCsv?: string;
  enableChoiceDataImport?: string;
  choiceImportBucket?: string;
  choiceImportPrefix?: string;
  choiceImportFileName?: string;
}

export type SMSTextTemplates = {
  template01: string;
};

export type EmailTemplates = {
  template01: string;
};

export type CleverConfig = {
  cleverToken: string;
  cleverDistrictId: string;
  cleverSchoolId: string;
  cleverGrades: string;
};

export type FormField = {
  label: string;
  type: FormType;
  name: string;
  id: string;
  value: string | boolean;
  options?: string[] | boolean[];
  spacing?: number;
  defaultTemplate?: string;
  tooltip?: string | ReactNode;
  visibleWhen?: {
    field: string;
    equals: string | boolean;
  };
};

export type FormGroup = {
  groupName: string;
  fields: FormField[];
};

export type FormData = {
  groups: FormGroup[];
};

export type AppConfigs = {
  siteConfigs?: SiteConfigs;
  SMSTextTemplates?: any;
  emailTemplates?: any; //EmailTemplates;
  cleverConfig?: CleverConfig;
  paisleyConfig?: any;
};

export type SiteImage = {
  [key in ImageConfigs]?: string | null;
};

export interface SeatLimitConfig {
  id?: string;
  organizationId: string;
  schoolId: string;
  limits: SeatLimitEntry[];
}

export interface SeatLimitEntry {
  grade: string;
  programId: string;
  limit: number;
}

export interface ClassroomSizeConfig {
  id?: string;
  organizationId: string;
  schoolId: string;
  classroomSizes: ClassroomSizeEntry[];
}

export interface ClassroomSizeEntry {
  grade: string;
  limit: number;
}

export interface FeederPatternConfig {
  id?: string;
  organizationId: string;
  schoolId: string;
  gradeSpan: FeederGradeSpan;
  feedsTo: FeederTarget[];
  growthRate: number;
}

export interface FeederGradeSpan {
  low: string;
  high: string;
}

export interface FeederTarget {
  schoolId: string;
  programs?: string[];
}

export interface FeederPatternImportResult {
  saved: number;
  total: number;
}

export interface SchoolTag {
  label: string;
  color: string;
}

export interface SchoolDirectoryEntry {
  schoolId: string;
  organizationId?: string;
  name: string;
  tags?: SchoolTag[];
}

export interface SchoolDirectoryBatchResult {
  saved: number;
  skipped: number;
  total: number;
}
